import PropTypes from 'prop-types';

import styles from './StatsBar.module.scss';
import {
    checkNullReturnZero,
    formatNumber2DPStringIfNotZeroOrHundred
} from 'utils/common';

const MarketAndTeamStats = (props) => {
    const {
        s1totalOutliers,
        s1percentOutliers,
        s2totalOutliers,
        s2percentOutliers,
        s3totalOutliers,
        s3percentOutliers,
        s4totalOutliers,
        s4percentOutliers
    } = props.stats;

    return (
        <>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(s1totalOutliers)}
                    </div>
                    <div className={styles.percentage}>
                        {formatNumber2DPStringIfNotZeroOrHundred(
                            s1percentOutliers
                        )}
                    </div>
                </div>
                <div className={styles.description}>S1 Outliers</div>
            </div>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(s2totalOutliers)}
                    </div>
                    <div className={styles.percentage}>
                        {formatNumber2DPStringIfNotZeroOrHundred(
                            s2percentOutliers
                        )}
                    </div>
                </div>
                <div className={styles.description}>S2 Outliers</div>
            </div>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(s3totalOutliers)}
                    </div>
                    <div className={styles.percentage}>
                        {formatNumber2DPStringIfNotZeroOrHundred(
                            s3percentOutliers
                        )}
                    </div>
                </div>
                <div className={styles.description}>S3 Outliers</div>
            </div>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(s4totalOutliers)}
                    </div>
                    <div className={styles.percentage}>
                        {formatNumber2DPStringIfNotZeroOrHundred(
                            s4percentOutliers
                        )}
                    </div>
                </div>
                <div className={styles.description}>S4 Outliers</div>
            </div>
        </>
    );
};

MarketAndTeamStats.propTypes = {
    stats: PropTypes.object
};

export default MarketAndTeamStats;
